import React, { useEffect, useState } from 'react';
import { Plus } from 'lucide-react';
import api from '../../utils/api';

const fmt = (n) => n === -1 ? 'Ilimitado' : n;
const fmtR = (n) => n === 0 ? 'Grátis' : `R$ ${n}`;

export default function AdminPlanos() {
  const [planos, setPlanos] = useState([]);
  const [overrides, setOverrides] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ tenant_id: '', plano: 'premium', motivo: '', expira_em: '' });

  useEffect(() => {
    Promise.all([
      api.get('/admin/planos'),
      api.get('/admin/planos/overrides'),
      api.get('/admin/tenants'),
    ]).then(([p, o, t]) => { setPlanos(p.data); setOverrides(o.data); setTenants(t.data); }).finally(() => setLoading(false));
  }, []);

  const createOverride = async (e) => {
    e.preventDefault();
    await api.post('/admin/planos/override', form);
    setShowModal(false);
    const [o, t] = await Promise.all([api.get('/admin/planos/overrides'), api.get('/admin/tenants')]);
    setOverrides(o.data); setTenants(t.data);
  };

  return (
    <div>
      <h1 className="text-xl font-bold text-stone-900 mb-6">Planos e Assinaturas</h1>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {planos.map(p => (
          <div key={p.id} className="bg-white border border-stone-200 rounded-xl p-5">
            <p className="font-bold text-stone-900 text-lg mb-0.5">{p.nome}</p>
            <p className="text-2xl font-bold text-[#0f3d2e] mb-3">{fmtR(p.preco)}<span className="text-sm font-normal text-stone-400">{p.preco > 0 ? '/mês' : ''}</span></p>
            <div className="space-y-1 text-xs text-stone-500">
              <p>Público: <span className="font-medium text-stone-700">{p.publico}</span></p>
              <p>Usuários: <span className="font-medium text-stone-700">{fmt(p.limite_usuarios)}</span></p>
              <p>Simulações: <span className="font-medium text-stone-700">{fmt(p.simulacoes_mes)}</span></p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white border border-stone-200 rounded-xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-stone-100">
          <h2 className="font-semibold text-stone-800 text-sm">Overrides Manuais</h2>
          <button onClick={() => setShowModal(true)} className="flex items-center gap-1.5 text-xs font-medium bg-[#0f3d2e] text-white px-3 py-1.5 rounded-lg hover:bg-[#0a2e22]">
            <Plus size={13} /> Novo Override
          </button>
        </div>
        {loading ? <div className="p-8 text-center text-stone-400 text-sm">Carregando...</div> : (
          <table className="w-full text-sm">
            <thead className="bg-stone-50 text-stone-500 text-xs">
              <tr><th className="text-left px-4 py-2">Tenant</th><th className="text-left px-4 py-2">De</th><th className="text-left px-4 py-2">Para</th><th className="text-left px-4 py-2">Motivo</th><th className="text-left px-4 py-2">Expira</th></tr>
            </thead>
            <tbody className="divide-y divide-stone-50">
              {overrides.length === 0
                ? <tr><td colSpan={5} className="px-4 py-6 text-center text-stone-400">Nenhum override</td></tr>
                : overrides.map(o => (
                  <tr key={o.id} className="hover:bg-stone-50">
                    <td className="px-4 py-3 font-medium text-stone-800">{tenants.find(t => t.id === o.tenant_id)?.nome || o.tenant_id}</td>
                    <td className="px-4 py-3 text-stone-500 capitalize">{o.plano_anterior}</td>
                    <td className="px-4 py-3"><span className="text-xs font-bold bg-teal-100 text-teal-700 px-2 py-0.5 rounded-full capitalize">{o.plano_novo}</span></td>
                    <td className="px-4 py-3 text-stone-400">{o.motivo || '—'}</td>
                    <td className="px-4 py-3 text-stone-400">{o.expira_em ? new Date(o.expira_em).toLocaleDateString('pt-BR') : 'Permanente'}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl w-full max-w-md shadow-xl">
            <div className="px-6 py-4 border-b border-stone-100 font-semibold text-stone-800">Novo Override de Plano</div>
            <form onSubmit={createOverride} className="p-6 space-y-4">
              <div><label className="text-xs font-medium text-stone-600 block mb-1">Tenant *</label>
                <select required value={form.tenant_id} onChange={e => setForm(f => ({...f, tenant_id: e.target.value}))} className="w-full border border-stone-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#0f3d2e]">
                  <option value="">Selecionar...</option>
                  {tenants.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                </select></div>
              <div><label className="text-xs font-medium text-stone-600 block mb-1">Plano *</label>
                <select required value={form.plano} onChange={e => setForm(f => ({...f, plano: e.target.value}))} className="w-full border border-stone-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#0f3d2e]">
                  {planos.map(p => <option key={p.id} value={p.id}>{p.nome}</option>)}
                </select></div>
              <div><label className="text-xs font-medium text-stone-600 block mb-1">Motivo</label>
                <input value={form.motivo} onChange={e => setForm(f => ({...f, motivo: e.target.value}))} className="w-full border border-stone-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#0f3d2e]" /></div>
              <div><label className="text-xs font-medium text-stone-600 block mb-1">Expira em</label>
                <input type="date" value={form.expira_em} onChange={e => setForm(f => ({...f, expira_em: e.target.value}))} className="w-full border border-stone-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#0f3d2e]" /></div>
              <div className="flex gap-3 pt-2">
                <button type="button" onClick={() => setShowModal(false)} className="flex-1 border border-stone-200 rounded-lg py-2.5 text-sm font-medium text-stone-600">Cancelar</button>
                <button type="submit" className="flex-1 bg-[#0f3d2e] text-white rounded-lg py-2.5 text-sm font-medium hover:bg-[#0a2e22]">Aplicar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
